/* tslint:disable */
import AdalConfig from "./AdalConfig";
export default class AdalConfigProvider {
  /**
   * Get the Azure Active Directory (ADAL) configuration
   */
  public get getAdalConfig(): AdalConfig {
    const hostname = window && window.location && window.location.hostname;
    switch (hostname) {
      case "localhost":
        return {
          tenant: "nordfab.onmicrosoft.com",
          clientId: "d61664ce-4f18-4b0e-ad2d-d0f780d0ccc4",
          //clientId: 'eb7417b0-17bd-47e0-9f21-421cca21c7d3',     // Production
          // tenant: 'compago.se',                              // process.env.TENANT,
          // clientId: '27243fbf-40c0-4fb8-b6f4-f3b6380fcf9a',            // process.env.CLIENT_ID,
          redirectUri: "http://localhost:3000", // process.env.REPLY_URL
          postLogoutRedirectUri: window.location.origin + "/", // window.location.origin
          additionalQueryParameter: "nux=1" // ???
        };
      case "nedermanqsotest.azurewebsites.net":
        return {
          tenant: "nordfab.onmicrosoft.com", // process.env.TENANT,
          //clientId: 'f6af87b9-9760-4cc3-bc15-4bb599b613be',            // Old ,
          clientId: "d61664ce-4f18-4b0e-ad2d-d0f780d0ccc4", // process.env.CLIENT_ID,
          redirectUri: "https://nedermanqsotest.azurewebsites.net", // process.env.REPLY_URL
          postLogoutRedirectUri: window.location.origin + "/", // window.location.origin
          additionalQueryParameter: "nux=1" // ???
        };
      default:
        return {
          tenant: "nordfab.onmicrosoft.com", // process.env.TENANT,
          //clientId: 'f6af87b9-9760-4cc3-bc15-4bb599b613be',            // Old ,
          clientId: "2d120b62-363e-49f8-b0c3-9e1cd345ce55", // process.env.CLIENT_ID,
          redirectUri: "https://myquicksolutionsonline.com", // process.env.REPLY_URL
          postLogoutRedirectUri: window.location.origin + "/", // window.location.origin
          additionalQueryParameter: "nux=1" // ???
        };
    }
  }
}



// WEBPACK FOOTER //
// ./src/adal/AdalConfigProvider.tsx